const getOutcomeCandidates = (response) => [
    response?.data?.result,
    response?.data,
    response?.result,
    response,
].filter(Boolean);

const getBooleanOutcome = (response, key) => {
    const outcome = getOutcomeCandidates(response).find(
        (candidate) => typeof candidate?.[key] === "boolean",
    );
    return outcome?.[key] === true;
};

export const normalizeAnnualReviewOutcome = (response) => ({
    response,
    reviewCompleted: getBooleanOutcome(response, "reviewCompleted"),
    changesApplied: getBooleanOutcome(response, "changesApplied"),
});
